<template>
  <v-card flat>
    <v-card-title>
      <h2>Collector Log Levels</h2>
      <v-btn text icon color="grey lighten-1" @click="refresh" :loading="loadingCollectors || loading">
        <v-icon>fas fa-sync</v-icon></v-btn>
      <v-select :items="allCollectors" v-model="selectedCollectorId"
      item-text="id" item-value="id" label="Source Collector"
      ></v-select>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="fal fa-search"
        placeholder="Search"
        single-line
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :items="filteredLogLevels()"
      :search="search"
      :loading="loading"
      :headers="headers"
      class="elevation-1"
    >
      <template v-slot:item.loglevel="item">
        <td class="actions">
          <v-radio-group v-model="item.item.loglevel" row hide-details class="regular--text">
            <v-radio :key="1" :class="{'red--text': item.value === 'ERROR'}" label="Error" value="ERROR"></v-radio>
            <v-radio :key="2" :class="{'red--text': item.value === 'WARN'}" label="Warn" value="WARN"></v-radio>
            <v-radio :key="3" :class="{'red--text': item.value === 'INFO'}" label="Info" value="INFO"></v-radio>
            <v-radio :key="4" label="Debug" value="DEBUG"></v-radio>
            <v-radio :key="5" :class="{'red--text': item.value === 'TRACE'}" label="Trace" value="TRACE"></v-radio>
          </v-radio-group>
        </td>
      </template>
    </v-data-table>
    <v-card-actions>
      <button @click="save" class="btn btn-primary" :loading="saving">Apply Collector Log Levels</button>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import moment from 'moment'
export default {
  async created () {
    this.loading = true
    await this.$store.dispatch('collectors/getLogLevels')
    this.loading = false
  },
  computed: {
    ...mapGetters('collectors', {
        collectorloglevels: 'getLogLevels',
        allCollectors: 'getCollectors'
    })
  },
  data() {
    return {
      loading: false,
      loadingCollectors: false,
      search: '',
      pagination : {'sortBy': ['dateTime'], 'sortDesc': [true], 'rowsPerPage': this.rowsPerPage},
      headers: [
        {text: 'Collector', align: 'left', sortable: true, value: 'collector'},
        {text: 'Driver', align: 'left', sortable: false, value: 'driver'},
        {text: 'Log Level', align: 'left', sortable: false, value: 'loglevel'}
      ],
      logLevelOptions: ['INFO', 'DEBUG', 'WARN', 'ERROR', 'TRACE'],
      selectedCollectorId: null,
      saving: false
    }
  },
  watch: {
    orgContext: async function(val) {
      if (!val) {
        return;
      }

      this.loadingCollectors = true
      await this.$store.dispatch('collectors/getCollectors')
      this.loadingCollectors = false
      this.refresh()
    }
  },
  methods: {
    async refresh() {
      this.loading = true
      await this.$store.dispatch('collectors/getLogLevels')
      this.loading = false
    },
    async save() {

      if (!this.selectedCollectorId) {
        alert("Please select a source collector");
        return;
      }


      this.saving = true;
      let logLevels = {}

      let allLogLevels = this.filteredLogLevels()

      _.each(allLogLevels, (level) => {
        logLevels[level.driver] = level.loglevel
      })

      await this.$store.dispatch('collectors/saveLogLevels',{collectorId: this.selectedCollectorId, logLevels})
      this.saving = false;
    },
    filteredLogLevels() {
      let logLevels;
      if (!this.selectedCollectorId) {
        logLevels = this.collectorloglevels;
      } else {
        logLevels = _.filter(this.collectorloglevels, {collector: this.selectedCollectorId});
      }
      return logLevels;
    }
  }
}
</script>
<style scoped>
  .regular--text >>> .v-label {
    color: black;
    font-size: 10px;
  }

  .red--text >>> .v-label {
    color: red;
    font-size: 10px;
  }
</style>
